import Model from './model';

export default class Presenter {
  model: Model;

  constructor(model: Model) {
    this.model = model;
  }
}
